import { render } from "./QuotationDashboardListCmp.vue?vue&type=template&id=4791cc7c"
import script from "./QuotationDashboardListCmp.vue?vue&type=script&lang=js"
export * from "./QuotationDashboardListCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__